/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Lookup_New_Term_DefaultInputs */



/**
* | output |
* | --- |
* | "New Term" |
*
* @param {Knp_Lookup_New_Term_DefaultInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_lookup_new_term_default = /** @type {((inputs?: Knp_Lookup_New_Term_DefaultInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Lookup_New_Term_DefaultInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nouveau terme")
	if (locale === "de") return /** @type {LocalizedString} */ ("Neue Amtszeit")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nuovo termine")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Новый срок")
	if (locale === "es") return /** @type {LocalizedString} */ ("Nuevo término")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("新学期")
	if (locale === "ja") return /** @type {LocalizedString} */ ("新学期")
	if (locale === "hi") return /** @type {LocalizedString} */ ("नया शब्द")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Novo período")
	return /** @type {LocalizedString} */ ("New Term")
});